module.exports = __webpack_public_path__ + "static/img/LV@3x.66f2b504.jpg";